import {
  AsyncPipe,
  DecimalPipe,
  NgClass,
  NgIf,
  TitleCasePipe,
} from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input } from '@angular/core';

import { MatProgressBarModule } from '@angular/material/progress-bar';

import { TranslocoRootModule } from '@eai-tdv/core/transloco';

import { formatBytes } from '@eai-tdv/shared/functions';
import {
  IconSvgCheckComponent,
  IconSvgInfoComponent,
} from '@eai-tdv/shared/icon-svg';
import { TooltipDirective } from '@eai-tdv/shared/tooltip';

import { SpinnerComponent } from '../../../../../shared/components/spinner/spinner.component';
import { UploadResourceService } from '../../../upload-resource.service';
import { IUploadResourceItem } from '../../../upload-resource.types';

@Component({
  standalone: true,
  imports: [
    NgIf,
    AsyncPipe,
    TranslocoRootModule,
    MatProgressBarModule,
    DecimalPipe,
    TitleCasePipe,
    TooltipDirective,
    SpinnerComponent,
    NgClass,
    IconSvgInfoComponent,
    IconSvgCheckComponent,
  ],
  selector: 'tdv-upload-resource-progress-info',
  templateUrl: './upload-resource-progress-info.component.html',
  styleUrls: ['./upload-resource-progress-info.component.scss'],
})
export class UploadResourceProgressInfoComponent {
  @Input({ required: true }) public set item(v: IUploadResourceItem) {
    this.data = v;
    this.uploadId = v.uploadId;
    const sizeData = formatBytes(v.uploadSizeBytes);
    this.size = sizeData.size;
    this.type = sizeData.type;
    this.isError = Boolean(v.errorWatcher.value);
    this.errorMsg = ((): string => {
      if (v.errorWatcher.value instanceof Error) {
        return v.errorWatcher.value.message;
      } else if (v.errorWatcher.value instanceof HttpErrorResponse) {
        const list = v.errorWatcher.value?.error?.message;
        return list || 'Unknown error';
      } else if (typeof v.errorWatcher.value === 'string') {
        return v.errorWatcher.value;
      } else {
        return 'Unknown error';
      }
    })();
    this.isUuuidReceived = Boolean(v.resourceUuidWatcher.value);
  }
  @Input({ required: true }) public set progress(v: number) {
    this.progressVal = v;
    this.uploaded = (this.size * (v || 2)) / 100;
    this.isBlobLoaded = v === 100;
  }

  @Input({ required: true }) public isTypeDetectionProgress!: boolean;

  public errorMsg?: string;
  public get isUploadProcess(): boolean {
    return !!(this.progressVal && this.progressVal < 100);
  }

  public errMsg?: string;
  public data!: IUploadResourceItem;
  private uploadId!: number;
  public size!: number;
  public uploaded?: number;
  public type?: string;
  public progressVal?: number;
  public base64?: string;
  public isBlobLoaded?: boolean;
  public isError?: boolean;
  public isUuuidReceived?: boolean;

  constructor(private uploadResourceS: UploadResourceService) {}

  public close(): void {
    this.uploadResourceS.closeItem(this.uploadId);
  }

  public cancelCreation(): void {
    this.data.isCancelled = true;
    this.data.cancel$.next();
    this.close();
  }

  public retry(): void {
    this.uploadResourceS.createResource(this.data).subscribe();
  }
}
